// @vendors
import React, {useContext, useMemo} from 'react';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// @assets
import { toolbarStyles } from '../../../../assets/css/customToolbar-styles';
import { theme } from '../../../../assets/theme';
import { GeneralStyles } from '../../../../assets/css/general-style';

// @components material
import {
  ClearAllIcon,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '../../../../components/shared/MaterialUI';

// @components
import { DataTable } from '../../Admin';
import { AddNewEmployer } from '../AddNewEmployer';

// @helpers
import { permissionsForAddEmployer } from '../../../../helpers/FunctionsUtils';

export const CustomToolbar = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    getAllCompanies,
    rowsState,
    setRowsState,
  } = useContext(DataTable);
  const styles = useMemo(() => toolbarStyles(), []);
  const generalStyle = useMemo(() => GeneralStyles(), []);
  const gState = useSelector((state) => state);
  const user = gState?.user;
  
  const onSearchBarChange = (e) => {
    setRowsState((current) => ({
      ...current,
      filters: {...current.filters, name: e.target.value}
    }));
  };

  const clearSearch = () => {
    setRowsState((current) => ({
      ...current,
      filters: {status:'', name: ''}
    }));
    getAllCompanies({filters: {}});
  };

  const handleSearchBar = async (query) => {
    if(query){
      getAllCompanies();
    }
  };

  const actionToSelect = () => {
    if(rowsState?.filters?.name === '')return clearSearch();
    if(rowsState?.filters?.name?.length > 0)return handleSearchBar(rowsState?.filters?.name);
    return
  }

  return (
    <GridToolbarContainer sx={styles.toolbar}>
      <h2 style={{ color: theme.palette.primary.black }}>Employer list</h2>
      <Grid sx={{display: 'flex', gap: '10px', alignItems: 'center'}}>
        <TextField
          sx={styles.searchBox}
          value={rowsState?.filters?.name}
          id='searchCompany'
          placeholder='Search'
          onChange={(e) => onSearchBarChange(e)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if(rowsState?.filters?.name === '') return clearSearch()
              return handleSearchBar(rowsState?.filters?.name);
            }
          }}
          variant='outlined'
          InputProps={{
            endAdornment: (
              <InputAdornment position='start'>
                <IconButton
                  onClick={actionToSelect}
                  sx={generalStyle.iconButtonSearch}
                >
                  <SearchRoundedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Tooltip title="Clear filter">
          <IconButton
            onClick={() => {
              clearSearch()
              history.replace(location.pathname);
            }}
            sx={generalStyle.iconButtonSearch}
          >
            <ClearAllIcon />
          </IconButton>
        </Tooltip>
      </Grid>

      <GridToolbarFilterButton
        sx={{
          ...generalStyle.customButton,
          ...generalStyle.customButtonSm,
          width: '200px',
          flexDirection: 'row-reverse',
        }}
      />

      {permissionsForAddEmployer(user?.role) && <AddNewEmployer />}
    </GridToolbarContainer>
  );
};
